import find from 'lodash/find';

/**
 * Check if group is included in enabled groups
 * @param {string[]} allGroups
 * @param {string} group
 * @return {boolean}
 */
function hasCookieGroup(allGroups, group) {
    return !!find(allGroups, group);
}

/**
 * Check whether cookies for a group are allowed
 * @param {ICookieStore} state
 * @return {boolean}
 */
export default {
    areCookiesAllowed: (state) => (type) => {
        return hasCookieGroup(state.allowedGroups, type);
    },
};
